<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="show" width="800px">
        <div class="chat-selector">
            <div class="left-box">
                <el-input placeholder="搜索" v-model="searchText" size="small">
                    <i class="el-icon-search el-input__icon" slot="suffix"> </i>
                </el-input>
                <tabs :items="tabItems" :current="tabIdx" @change="onTabChange"></tabs>
                <!-- 最近聊天 -->
                <virtual-scroller v-if="tabIdx == 0" class="left-scroll-box" :items="showChats">
                    <template v-slot="{ item }">
                        <div class="chat-item" @click="onClickChatItem(item)">
                            <head-image :url="item.headImage" :name="item.showName" :size="42"></head-image>
                            <div class="chat-info">
                                <div class="chat-name">
                                    <div class="chat-name-text"> {{ item.showName }}</div>
                                    <div v-if="item.companyName" class="company-tag-mini">@{{ item.companyName }} </div>
                                    <el-tag v-if="item.type == 'GROUP'" type="primary">群</el-tag>
                                </div>
                                <div class="chat-content"
                                    v-html="$emo.transform($str.html2Escape(item.lastContent), 'emoji-small')">
                                </div>
                            </div>
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onChatChange(item)"></el-checkbox>
                        </div>
                    </template>
                </virtual-scroller>
                <!-- 好友 -->
                <virtual-scroller v-if="tabIdx == 1" class="left-scroll-box" :items="showFriends">
                    <template v-slot="{ item }">
                        <friend-item :menu="false" :friend="item" size="small" @click.native="onClickFriendItem(item)">
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onFriendChange(item)"></el-checkbox>
                        </friend-item>
                    </template>
                </virtual-scroller>
                <!-- 群聊 -->
                <virtual-scroller v-if="tabIdx == 2" class="left-scroll-box" :items="showGroups">
                    <template v-slot="{ item }">
                        <group-item :group="item" :menu="false" size="small" @click.native="onClickGroupItem(item)">
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onGroupChange(item)"></el-checkbox>
                        </group-item>
                    </template>
                </virtual-scroller>
                <!-- 标签 -->
                <div v-if="tabIdx == 3" class="left-scroll-box tag-tab">
                    <div class="tag-list">
                        <div v-for="tag in showTags" :key="tag.id" class="tag-item" 
                            :class="{ 'selected': tag.checked }" @click="onClickTagItem(tag)">
                            <el-checkbox v-model="tag.checked" @click.native.stop="" 
                                @change="onTagChange(tag)"></el-checkbox>
                            <i class="el-icon-collection-tag tag-icon"></i>
                            <span class="tag-name">{{ tag.name }}</span>
                            <span class="tag-count">{{ tag.memberCount }}人</span>
                        </div>
                        <div v-if="showTags.length === 0" class="empty-state">
                            <span>暂无标签</span>
                        </div>
                    </div>
                    <!-- 标签成员列表 -->
                    <div v-if="selectedTagMembers.length > 0" class="tag-members">
                        <div class="tag-members-title">已选标签的成员：</div>
                        <div class="tag-members-list">
                            <div v-for="member in selectedTagMembers" :key="member.id" class="member-item">
                                <head-image :url="member.headImage" :name="member.showName" :size="32"></head-image>
                                <span class="member-name">{{ member.showName }}</span>
                                <span v-if="member.inOtherSource" class="from-other">(来自其他来源)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="arrow el-icon-d-arrow-right"></div>
            <div class="right-box">
                <div class="tip">已勾选{{ checkedItems.length }}个联系人</div>
                <el-scrollbar class="right-scroll-box">
                    <div v-for="(item, idx) in checkedItems" :key="idx">
                        <div class="checked-item">
                            <head-image :url="item.headImage" :name="item.showName" :size="36"></head-image>
                            <div class="chat-name">
                                <div class="chat-name-text">{{ item.showName }}</div>
                                <div v-if="item.companyName" class="company-tag-mini"> @{{ item.companyName }}</div>
                            </div>
                            <div class="close" title="移除" @click.stop="onRemoveItem(item)"><i class="el-icon-close"></i>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close()">取 消</el-button>
            <el-button type="primary" @click="ok()">发 送</el-button>
        </span>
    </el-dialog>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';
import Tabs from '../common/Tabs.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import FriendItem from '../friend/FriendItem.vue';
import GroupItem from '../group/GroupItem.vue';

export default {
    components: { VirtualScroller, HeadImage, Tabs, FriendItem, GroupItem },
    name: "chatSelector",
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            show: false,
            searchText: "",
            callback: null,
            tabIdx: 0,
            tabItems: ['最近聊天', '好友', '群聊', '标签'],
            chats: [],
            friends: [],
            groups: [],
            tags: [],
            tagMembersCache: {},
            checkedItems: []
        }
    },
    methods: {
        open(callback) {
            this.tabIdx = 0;
            this.searchText = "";
            this.show = true;
            this.callback = callback;
            this.initData();
        },
        initData() {
            this.checkedItems = []
            this.chats = [];
            this.friends = [];
            this.groups = [];
            this.loadTags();
            this.chatStore.chats.forEach(chat => {
                if ((chat.type == 'PRIVATE' && this.friendStore.isFriend(chat.targetId))
                    || (chat.type == 'GROUP' && this.groupStore.isGroup(chat.targetId))) {
                    this.chats.push({
                        type: chat.type,
                        targetId: chat.targetId,
                        headImage: chat.headImage,
                        showName: chat.showName,
                        lastContent: chat.lastContent,
                        companyName: chat.companyName,
                        checked: false
                    })
                }
            })
            this.friendStore.friends.forEach(friend => {
                if (!friend.deleted) {
                    this.friends.push({
                        id: friend.id,
                        headImage: friend.headImage,
                        showNickName: friend.showNickName,
                        companyName: friend.companyName,
                        checked: false
                    })
                }
            })
            this.groupStore.groups.forEach(group => {
                if (!group.quit) {
                    this.groups.push({
                        id: group.id,
                        headImage: group.headImage,
                        headImageThumb: group.headImageThumb,
                        showGroupName: group.showGroupName,
                        checked: false
                    })
                }
            })
        },
        close() {
            this.show = false;
        },
        ok() {
            this.close();
            this.callback(this.checkedItems);
        },
        onTabChange(idx) {
            this.tabIdx = idx;
            this.updateCheckboxStates();
        },
        updateCheckboxStates() {
            this.chats.forEach(chat => {
                chat.checked = this.checkedItems.some(chatItem => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            })
            this.friends.forEach(f => {
                f.checked = this.checkedItems.some(chatItem => chatItem.type == 'PRIVATE' && chatItem.targetId == f.id);
            })
            this.groups.forEach(g => {
                g.checked = this.checkedItems.some(chatItem => chatItem.type == 'GROUP' && chatItem.targetId == g.id);
            })
            this.updateTagCheckboxStates();
        },
        onClickChatItem(chatItem) {
            chatItem.checked = !chatItem.checked;
            this.onChatChange(chatItem);
        },
        onChatChange(chatItem) {
            let idx = this.checkedItems.findIndex(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                this.checkedItems.push(chatItem)
            }
        },
        onClickFriendItem(friend) {
            friend.checked = !friend.checked;
            this.onFriendChange(friend);
        },
        onFriendChange(friend) {
            let idx = this.checkedItems.findIndex(chat => chat.type == 'PRIVATE' && chat.targetId == friend.id);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                let chatItem = {
                    targetId: friend.id,
                    type: 'PRIVATE',
                    showName: friend.showNickName,
                    headImage: friend.headImage,
                    companyName: friend.companyName
                }
                this.checkedItems.push(chatItem)
            }
        },
        onClickGroupItem(group) {
            group.checked = !group.checked;
            this.onGroupChange(group);
        },
        onGroupChange(group) {
            let idx = this.checkedItems.findIndex(chat => chat.type == 'GROUP' && chat.targetId == group.id);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                let chatItem = {
                    targetId: group.id,
                    type: 'GROUP',
                    showName: group.showGroupName,
                    headImage: group.headImageThumb
                }
                this.checkedItems.push(chatItem)
            }
        },
        onClickTagItem(tag) {
            tag.checked = !tag.checked;
            this.onTagChange(tag);
        },
        onTagChange(tag) {
            if (!this.tagMembersCache[tag.id]) {
                this.loadTagMembers(tag);
            } else {
                this.syncTagMembersToChecked(tag);
            }
        },
        loadTagMembers(tag) {
            this.$http({
                url: `/friend/tag/detail/${tag.id}`,
                method: 'get'
            }).then(data => {
                const members = (data.members || []).map(member => ({
                    id: member.friendId,
                    headImage: member.headImage,
                    showName: member.showNickName || member.nickName,
                    companyName: member.companyName,
                    targetId: member.friendId,
                    type: 'PRIVATE'
                }));
                this.tagMembersCache[tag.id] = members;
                this.syncTagMembersToChecked(tag);
            }).catch(() => { });
        },
        syncTagMembersToChecked(tag) {
            const members = this.tagMembersCache[tag.id] || [];
            if (tag.checked) {
                members.forEach(member => {
                    const exists = this.checkedItems.some(item => 
                        item.type == 'PRIVATE' && item.targetId == member.targetId
                    );
                    if (!exists) {
                        this.checkedItems.push(member);
                    }
                });
            } else {
                members.forEach(member => {
                    const inOtherSource = this.isInOtherSource(member.targetId);
                    if (!inOtherSource) {
                        const idx = this.checkedItems.findIndex(item => 
                            item.type == 'PRIVATE' && item.targetId == member.targetId
                        );
                        if (idx >= 0) {
                            this.checkedItems.splice(idx, 1);
                        }
                    }
                });
            }
        },
        isInOtherSource(userId) {
            const inChat = this.chats.some(c => c.type == 'PRIVATE' && c.targetId == userId && c.checked);
            const inFriend = this.friends.some(f => f.id == userId && f.checked);
            return inChat || inFriend;
        },
        onRemoveItem(chatItem) {
            let idx = this.checkedItems.findIndex(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            this.checkedItems.splice(idx, 1);
            let chat = this.chats.find(c => c.type == chatItem.type && c.targetId == chatItem.targetId);
            if (chat) {
                chat.checked = false;
            }
            if (chatItem.type == 'PRIVATE') {
                let friend = this.friends.find(f => f.id == chatItem.targetId);
                if (friend) {
                    friend.checked = false;
                }
                // 同步标签成员的选中状态
                this.tags.forEach(tag => {
                    if (this.tagMembersCache[tag.id]) {
                        this.tagMembersCache[tag.id].forEach(member => {
                            if (member.id == chatItem.targetId) {
                                member._checked = false;
                            }
                        });
                    }
                });
            }
            if (chatItem.type == 'GROUP') {
                let group = this.groups.find(g => g.id == chatItem.targetId);
                if (group) {
                    group.checked = false;
                }
            }
            // 更新标签的选中状态
            this.updateTagCheckboxStates();
        },
        updateTagCheckboxStates() {
            this.tags.forEach(tag => {
                const members = this.tagMembersCache[tag.id] || [];
                tag.checked = members.length > 0 && members.every(m => 
                    this.checkedItems.some(item => item.type == 'PRIVATE' && item.targetId == m.id)
                );
            });
        },
        loadTags() {
            this.$http({
                url: '/friend/tag/list',
                method: 'get'
            }).then(data => {
                this.tags = (data || []).map(tag => ({
                    ...tag,
                    checked: false
                }));
            }).catch(() => { });
        }
    },
    computed: {
        showChats() {
            return this.chats.filter(chat => chat.showName.includes(this.searchText))
        },
        showFriends() {
            return this.friends.filter(f => f.showNickName.includes(this.searchText))
        },
        showGroups() {
            return this.groups.filter(g => g.showGroupName.includes(this.searchText))
        },
        showTags() {
            return this.tags.filter(tag => tag.name.includes(this.searchText))
        },
        selectedTagMembers() {
            let members = [];
            this.tags.forEach(tag => {
                if (tag.checked && this.tagMembersCache[tag.id]) {
                    this.tagMembersCache[tag.id].forEach(member => {
                        const exists = members.some(m => m.targetId == member.targetId);
                        if (!exists) {
                            const inOther = this.isInOtherSource(member.targetId);
                            members.push({ ...member, inOtherSource: inOther });
                        }
                    });
                }
            });
            return members;
        }
    }
}
</script>

<style scoped lang="scss">
.chat-selector {
    display: flex;

    .left-box {
        width: 48%;
        overflow: hidden;
        border: var(--im-border);

        .left-scroll-box {
            height: 400px;

            .check-box {
                margin-right: 10px;
            }

            .chat-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                cursor: pointer;

                .chat-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    padding: 0 10px;
                    text-align: left;
                    overflow: hidden;

                    .chat-name {
                        flex: 1;
                        display: flex;
                        align-items: center;

                        .chat-name-text {
                            font-size: var(--im-font-size);
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }

                    .chat-content {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: var(--im-font-size-small);
                        color: var(--im-text-color-light);
                    }
                }

                &:hover {
                    background-color: var(--im-background-active);
                }
            }
        }

        .tag-tab {
            padding: 0;
            overflow: auto;

            .tag-list {
                padding: 8px 0;

                .tag-item {
                    display: flex;
                    align-items: center;
                    padding: 8px 12px;
                    cursor: pointer;

                    &:hover {
                        background-color: var(--im-background-active);
                    }

                    &.selected {
                        background-color: var(--im-background-hover);
                    }

                    .tag-icon {
                        margin-left: 8px;
                        color: var(--im-color-primary);
                    }

                    .tag-name {
                        flex: 1;
                        margin-left: 8px;
                        font-size: var(--im-font-size);
                    }

                    .tag-count {
                        color: var(--im-text-color-light);
                        font-size: var(--im-font-size-small);
                    }
                }

                .empty-state {
                    padding: 20px;
                    text-align: center;
                    color: var(--im-text-color-light);
                }
            }

            .tag-members {
                border-top: var(--im-border);
                padding: 8px 12px;
                max-height: 200px;
                overflow-y: auto;

                .tag-members-title {
                    font-size: var(--im-font-size-small);
                    color: var(--im-text-color-light);
                    margin-bottom: 8px;
                }

                .tag-members-list {
                    .member-item {
                        display: flex;
                        align-items: center;
                        padding: 4px 0;

                        .member-name {
                            margin-left: 8px;
                            font-size: var(--im-font-size-small);
                        }

                        .from-other {
                            margin-left: 4px;
                            font-size: var(--im-font-size-small);
                            color: var(--im-color-primary);
                        }
                    }
                }
            }
        }
    }

    .arrow {
        display: flex;
        align-items: center;
        font-size: 20px;
        padding: 10px;
        color: var(--im-color-primary);
    }

    .right-box {
        width: 48%;
        border: var(--im-border);

        .tip {
            text-align: left;
            height: 32px;
            line-height: 32px;
            text-indent: 10px;
            color: var(--im-text-color-light)
        }

        .right-scroll-box {
            height: 460px;

            .checked-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                white-space: nowrap;
                cursor: pointer;


                .chat-name {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    padding: 0 10px;

                    .chat-name-text {
                        font-size: var(--im-font-size);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .close {
                    width: 30px;
                    display: none;
                }

                &:hover {
                    background-color: var(--im-background-active);
                }

                &:hover .close {
                    display: block;
                }
            }
        }
    }
}
</style>
